export const getMessagePosition = (message, userId) =>
	(message.sender || message.created_by) === userId ? 'flex-end' : 'flex-start';
